<wl-modal
  (closeModal)="cancel()"
  [modalTitle]="content().title"
  trackImpression="contentblock-impression"
  [trackImpressionInfo]="rendering()"
  [trackImpressionName]="'consents'"
  class="consents-modal"
>
  <ng-template wlModalBody>
    <div *wlGenericRichText="content().body"></div>

    <div class="mt-2 mb-3">
      <div class="form-check mb-2">
        <input
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="energyAdviceEmailRejected"
          id="energy-advice"
        />
        <label class="form-check-label" for="energy-advice">
          {{ content().energyAdviceCheckbox }}
        </label>
      </div>

      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="sustainabilityAdviceEmailRejected"
          id="sustainability"
        />
        <label class="form-check-label" for="sustainability">
          {{ content().sustainabilityCheckbox }}
        </label>
      </div>
    </div>

    <div>
      <crnt-button
        tabindex="0"
        variant="primary"
        wlAutomationId="modal.primaryButton"
        (click)="confirm()"
        >{{ content().primaryButton }}</crnt-button
      >
      <crnt-button
        tabindex="0"
        variant="tertiary"
        wlAutomationId="modal.secondaryButton"
        (click)="cancel()"
        >{{ content().secondaryButton }}</crnt-button
      >
    </div>
  </ng-template>
</wl-modal>
